import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'table-action-bar',
  templateUrl: './table-action-bar.component.html',
})
export class TableActionBarComponent implements OnInit {

  @Output() toggleColumns = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

}
